import SquigglyLine1Icon from '@/assets/icons/squiggly-lines/squiggly-line-1.svg?react';
import SquigglyLine8Icon from '@/assets/icons/squiggly-lines/squiggly-line-8.svg?react';
import microscopeImg from '@/assets/images/home/microscope.png';
import supplementsBoxImg from '@/assets/images/home/supplements-box.png';
import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { ArrowRight as ArrowRightIcon } from '@carbon/icons-react';

const supplementFeatures = [
  {
    title: 'Convenient care, 100% online process',
    description: 'Get started from anywhere — no clinic visits needed.',
    imgSrc: supplementsBoxImg,
    linkText: 'Find your doctor',
    linkHref: routes.auth.login,
  },
  {
    title: 'Clinically proven ingredients',
    description:
      'Lab tested, doctor trusted, backed by science, made for real results.',
    imgSrc: microscopeImg,
    linkText: 'Our standards',
    linkHref: routes.ingredients.index,
  },
];

export function SupplementsSection() {
  const { isDesktop } = useBreakpoint();

  return (
    <Section containerClassName="bg-muted">
      <Heading
        as="h2"
        className="mx-auto mb-6 leading-10 lg:mb-15 lg:max-w-150.5 lg:leading-14"
        underlinedText="reimagined"
        underline={
          isDesktop ? (
            <SquigglyLine8Icon className="-bottom-2.25 -left-1" />
          ) : (
            <SquigglyLine1Icon className="-bottom-1" />
          )
        }
      >
        Supplements, reimagined for modern life
      </Heading>

      <div className="flex flex-col gap-7.5 lg:flex-row lg:gap-5">
        {supplementFeatures.map(
          ({ title, description, imgSrc, linkText, linkHref }) => (
            <div
              key={title}
              className="bg-card flex flex-col overflow-hidden rounded-[1.25rem] px-5.5 py-12 text-center lg:w-full"
            >
              <Heading
                as="h3"
                size={isDesktop ? 'h3' : 'h4'}
                className="mb-4 lg:mx-auto lg:max-w-86.5"
              >
                {title}
              </Heading>

              <p className="text-muted-foreground mb-8 lg:mx-auto lg:max-w-107.5">
                {description}
              </p>

              <img
                className="mb-4 h-61.25 w-full scale-120 object-contain sm:scale-100 lg:mt-auto lg:h-78.75"
                src={imgSrc}
                alt={title}
              />

              <Button
                variant="outlinePrimary"
                animate
                asChild
                className="lg:mx-auto"
              >
                <a href={linkHref}>
                  <ArrowRightIcon className="size-6" />
                  <p>{linkText}</p>
                </a>
              </Button>
            </div>
          ),
        )}
      </div>
    </Section>
  );
}
